/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a countdown for any duration and start it instantly. An alarm sounds when the time is up, and the timer keeps accurate time even if you switch tabs.`)
};

const es_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura una cuenta regresiva para cualquier duración e inícala al instante. Suena una alarma cuando se acaba el tiempo, y el temporizador mantiene la hora exacta aunque cambies de pestaña.`)
};

const de_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle einen Countdown für eine beliebige Dauer ein und starte ihn sofort. Ein Alarm ertönt, wenn die Zeit abgelaufen ist, und der Timer läuft auch dann genau weiter, wenn du den Tab wechselst.`)
};

const nl_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel een aftelling in voor elke duur en start deze direct. Er klinkt een alarm als de tijd om is, en de timer houdt de tijd nauwkeurig bij, ook als je van tabblad wisselt.`)
};

const fr_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglez un compte à rebours pour n’importe quelle durée et démarrez-le instantanément. Une alarme retentit quand le temps est écoulé, et le minuteur reste précis même si vous changez d’onglet.`)
};

const it_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta un countdown per qualsiasi durata e avvialo all'istante. Un allarme suona allo scadere del tempo, e il timer resta preciso anche se cambi scheda.`)
};

const pt_br2_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina uma contagem regressiva para qualquer duração e inicie-a na hora. Um alarme toca quando o tempo acaba, e o temporizador mantém a contagem precisa mesmo se você trocar de aba.`)
};

const pt_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina uma contagem decrescente para qualquer duração e inicie-a de imediato. Um alarme toca quando o tempo termina, e o temporizador mantém a hora exata mesmo que mude de separador.`)
};

const ja_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の時間でカウントダウンを設定し、すぐにスタートできます。時間になるとアラームが鳴り、タブを切り替えても正確に時間を計測し続けます。`)
};

const zh_timer_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置任意时长的倒计时并立即开始。时间到时会响起闹铃，即使切换标签页，计时器也能保持准确计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_intro", locale)
	if (locale === "en") return en_timer_hub_intro(inputs)
	if (locale === "es") return es_timer_hub_intro(inputs)
	if (locale === "de") return de_timer_hub_intro(inputs)
	if (locale === "nl") return nl_timer_hub_intro(inputs)
	if (locale === "fr") return fr_timer_hub_intro(inputs)
	if (locale === "it") return it_timer_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_intro(inputs)
	if (locale === "pt") return pt_timer_hub_intro(inputs)
	if (locale === "ja") return ja_timer_hub_intro(inputs)
	return zh_timer_hub_intro(inputs)
};